import { BuyerActionTypes, All } from '../actions/buyerActions';

export interface State {
  buyer: Array<any> | null;
}

const initialState: State =
{
  buyer: null
}

export function buyerReducer(state = initialState, action: All): State {
  
  switch (action.type) {
    case BuyerActionTypes.BUYER_SUCCESS: {
      return {
        ...state,
        buyer: action.payload.buyer
      };
    }
    case BuyerActionTypes.BUYER_FAILURE: {
      return {
        ...state,
      };
    }
    default: {
      return state;
    }
  }
}
